export enum ELocalization {
  ENGLISH = 'es-US',
  FRENCH = 'fr-CA'
}
